import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { eventSet }  from '../../store/eventSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faFileExcel, faLink, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import useApiGet from '../../hooks/useApiGet';
import LogoForm from '../common/LogoForm';
import EventToAdminList from './EventToAdminList';
import EventStickersList from './EventStickersList';
import EventCategoriesList from './EventCategoriesList';
import Tooltip from '../common/Tooltip';
import './EventView.css';
import CounterDelete from './CounterDelete';
import EventDates from './EventDates';
import { API_URL } from '../../config';
import { get } from '../../utils/api';
import getLogo from '../../utils/getLogo';

const EventView = () => {
    const { id, action } = useParams();
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const user = useSelector(state => state.auth.user);
	const [ update, setUpdate ] = useState(true);
	const [ isAdmin, setIsAdmin ] = useState(false);
	const [ data, error, isLoading ] = useApiGet({ method: '/events/' + id, params: update });

	useEffect(() => {
		if(data) {
			dispatch(eventSet(data.event));
		}
	},[data, dispatch]);

	// Определим является ли юзер админом выставки
	useEffect(() => {
		const fetch = async (event_id) => {
			setIsAdmin(false);
			const result = await get('/a2e', { event: event_id });
			if(result.error) return;
			for(let i = 0; i < result.data.a2e.length; i ++) {
				let admin_id = result.data.a2e[i].admin._id;
				if(user._id === admin_id) {
					setIsAdmin(true);
					return;
				}
			}
		};

		if (data) fetch(data.event._id); else setIsAdmin(false);
	}, [ data, user ]);

	const onExportCatalog = () => {
		const url  = `${API_URL}/export/catalog?event=${id}&lang=${lang}`;
		//console.log(url);
		window.open(url);
	};

	const onExportActivities = () => {
		const url  = `${API_URL}/export/activities?event=${id}&lang=${lang}`;
		//console.log(url);
		window.open(url);
	};

	return (
		<div>
	    	<h1>{data ? data.event.name[lang] : t('eventview.title')}</h1>
            {error && <p className='error'>{t(error)}</p>}
            {action === 'created' && <p className='success'>{t('eventview.created')}</p>}
            {action === 'updated' && <p className='success'>{t('eventview.updated')}</p>}
			{isLoading && <p>{t('loader.title')}</p>}
            {data &&
			<React.Fragment>
				{(isAdmin || user.role === 'root') && <React.Fragment>
					{t('logo.title')}
					<Tooltip>
						{t('logo.type')}<br/>
						{t('logo.size')}<br/>
						{t('logo.dimension')}
					</Tooltip>
				</React.Fragment>}

				<div className='Event'>
					<div className='Event-logo'>
						{(isAdmin || user.role === 'root') ?
							<LogoForm target={data}/> :
							<img src={getLogo(data.event)} alt={data.event.name[lang]}/>
						}
					</div>
					{(isAdmin || user.role === 'root') && <div className='Event-text'>
						{/*<h2>{data.event.name[lang]}</h2>*/}

						<p>
							<span
								onClick={() => navigate('/cabinet/eventedit')}
								style={{color:'var(--main-color)', cursor:'pointer'}}
							>
								<Icon icon={faPenToSquare} size='lg' fixedWidth/>&nbsp;
								<u>{t('common.edit')}</u>
							</span>
						</p>
						
						<p>
							<span
								onClick={() => onExportCatalog()}
								style={{color:'var(--main-color)', cursor:'pointer'}}
							>
								<Icon icon={faFileExcel} size='lg' fixedWidth/>&nbsp;
								<u>{t('eventview.export_catalog')}</u>
							</span>
						</p>

						<p>
							<span
								onClick={() => onExportActivities()}
								style={{color:'var(--main-color)', cursor:'pointer'}}
							>
								<Icon icon={faFileExcel} size='lg' fixedWidth/>&nbsp;
								<u>{t('eventview.export_events')}</u>
							</span>
						</p>

						<p>
							<span
								onClick={() => navigate(`/cabinet/preset/${data.event._id}`)}
								style={{color:'var(--main-color)', cursor:'pointer'}}
							>
								<Icon icon={faLink} size='lg' fixedWidth/>&nbsp;
								<u>{t('eventview.preset')}</u>
							</span>
						</p>

						<p>
							<span
								onClick={() => navigate(`/cabinet/expodat/${data.event._id}`)}
								style={{color:'var(--main-color)', cursor:'pointer'}}
							>
								<Icon icon={faArrowUpRightFromSquare} size='lg' fixedWidth/>&nbsp;
								<u>{t('eventview.expodat')}</u>&nbsp;
								<span className='small' style={{ color: 'var(--gray-color)'}}>
									({data.event.expodat.is_export ? 'On' : 'Off'})
								</span>
							</span>
						</p>

					</div>}
				</div>
			</React.Fragment>}

			{data && <EventDates event={data.event}/>}
			{data && <EventCategoriesList event={data.event}/>}
			{data && <EventStickersList event={data.event}/>}
			{data && <EventToAdminList event={data.event}/>}

			{data &&
			<React.Fragment>
				<h2>{t('eventview.files')}</h2>
				{data.event.is_files_available ?
				<div>{t('eventview.files_available')}</div> :
				<div>{t('eventview.files_unavailable')}</div>}
			</React.Fragment>}

			{data &&
			<React.Fragment>
				<h2>
					{t('eventview.counter')}
					{data.event.counter
					? <CounterDelete event_id={data.event._id} onDelete={() => setUpdate(!update)}/>
					: <span onClick={() => navigate(`/cabinet/counteradd/${data.event._id}`)}>{t('common.add')}</span>}
				</h2>
				{!data.event.counter ? t('eventview.nocounter') : <ul>
					<li>current: {data.event.counter.value} ({getDate(data.event.counter.date)})</li>
					<li>start: {data.event.counter.start.value} ({getDate(data.event.counter.start.date)})</li>
					<li>stop: {data.event.counter.stop.value} ({getDate(data.event.counter.stop.date)})</li>
				</ul>}
			</React.Fragment>}

		</div>
	);
};

const getDate = (date) => {
	const d = new Date();
	d.setTime(date);
	return d.toLocaleDateString();
};

export default EventView;
